<template>
  <div class="app-ven-imp">
    <div class="drop">
      <div ref="drop_area" class="noselect" :class="seletor.class">
        <div v-if="envio !== null">
          <template v-if="envio === 'validando'">
            Estamos validando o arquivo recebido.
          </template>
          <template v-else>
            Estamos criando as vendas solicitadas.
          </template>
          <br/>
          <br/>
          Por favor aguarde só mais alguns instantes...
        </div>

        <!-- SETA O TITULO DO CAMPO -->
        <div class="titulo" v-show="envio === null">
          <span>Importação de vendas</span>
          <br/>
          <br/>
          Selecione ou arraste nesta área um arquivo com a extensão .json
          <br/>
          <br/>
        </div>

        <!-- SETA A OPÇÃO PARA ESCOLHER UM ARQUIVO -->
        <span v-show="envio === null">
          <input :id='seletor.id + "-input"' name="files[]" accept=".json,.JSON,.Json" :disabled="seletor.disabled" :value="seletor.value" :multiple="false" type="file" @change="seletor.onChange"/>
          <label :for='seletor.id + "-input"'><strong>Escolha um arquivo</strong><span> ou arraste-o aqui</span>.</label>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.app-ven-imp {
  margin-top: 30px;
}

.app-ven-imp > .drop {
  max-height: 250px;
  min-height: 250px;
}
.app-ven-imp > .drop {
  width: 600px;
  height: 200px;
  margin: 0px auto;
}
  .app-ven-imp > .drop > div > .titulo {
    font-size: calc(100% + 1px);
    /* font-weight: bold; */
  }
    .app-ven-imp > .drop > div > .titulo > span {
      font-weight: bold;
      text-decoration: underline;
      text-transform: uppercase
    }
  .app-ven-imp > .drop > .ven-imp-box-upload {
    width: 600px;
    height: 200px;
    display: table-cell;
    vertical-align: middle;
    border-radius: 5px;

    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: all 0.3s ease-in-out;

    background-color: #c8dadf;
    padding: 30px 20px;
    text-align: center;
  }
    .app-ven-imp > .drop > .ven-imp-box-upload > span > input {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
      .app-ven-imp > .drop > .ven-imp-box-upload > span > label {
        cursor: pointer;
        color: #0f3c4b;
        font-size: var(--font-base-soma-15);
      }
      .app-ven-imp > .drop > .ven-imp-box-upload > span > input:disabled ~ label {
        cursor: no-drop;
      }
      .app-ven-imp > .drop > .ven-imp-box-upload > span > label:hover strong {
        color: #39bfd3;
        font-weight: bold;
      }
  .app-ven-imp > .drop > .ven-imp-box-upload-dragover {
    outline-offset: -20px;
    outline-color: #c8dadf;
    background-color: #f9f9f9;
  }
</style>

<script>
export default {
  props: {
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      envio: null,
      seletor: {
        id: 'app-ven-imp',
        class: 'ven-imp-box-upload',
        value: '',
        qrcode: '',
        disabled: false,
        onChange: this.appVenImportarOnChangeInput
      }
    }
  },
  mounted: function () {
    this.appVenImportarSeletorObservadorIniciar()
  },
  methods: {
    appVenImportarSeletorObservadorIniciar: function (tentativa = 0) {
      if (tentativa <= 10) {
        setTimeout(() => {
          if ([ '', null, undefined ].indexOf(this.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.drop_area) !== -1) {
            this.appVenImportarSeletorObservadorIniciar((tentativa + 1))
          } else {
            var funcao = (force = false, requestId = '') => {
              if (force === true || this.seletor.requestId === requestId) {
                // SETA A CLASSE DO CAMPO
                this.seletor.class = [ 'ven-imp-box-upload' ]

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }
            }

            // ADICIONA O EVENTO AO COLOCAR UM ARQUIVO SOBRE O CAMPO
            $(this.$refs.drop_area).on('dragover', (event) => {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // SETA O REQUEST ID
              var flag = Math.floor(Math.random() * (9999 - 1000)) + 1000

              // SETA O ID GERADO
              this.seletor.requestId = flag

              // SETA A CLASSE DO CAMPO
              this.seletor.class = [ 'ven-imp-box-upload', 'ven-imp-box-upload-dragover' ]

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA LIMPAR O STATUS APÓS 200MS
              setTimeout(function () { funcao(false, flag) }, 200)
            })

            // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
            $(this.$refs.drop_area).on('dragenter', (event) => {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // CHAMA A FUNÇÃO PARA LIMPAR O STATUS
              funcao(true)
            })

            // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
            $(this.$refs.drop_area).on('drop', (event) => {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // DESABILITA O INPUT PARA INSERIR NOVO
              this.seletor.disabled = true

              // LIMPA O STATUS PARA PARAR O PROCESSO
              this.seletor.requestId = ''

              // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
              this.seletor.value = []

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
              this.appVenImportarArquivoLer(event.originalEvent.dataTransfer.files[0])

              // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
              this.appVenImportarVerificarStatusSeletor()
            })
          }
        }, tentativa === 0 ? 1 : 200)
      }
    },
    appVenImportarOnChangeInput: function (event) {
      // LIMPA OS DADOS DO INPUT
      this.seletor.value = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // PEGA O ARQUIVO
      var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

      // VERIFICA SE TEM ALGUM ARQUIVO PARA SALVAR
      if (arquivo.files.length >= 1) {
        // DESABILITA O INPUT PARA INSERIR NOVO
        this.seletor.disabled = true

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
        this.appVenImportarArquivoLer(arquivo.files[0])
      }

      // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
      this.appVenImportarVerificarStatusSeletor()
    },
    appVenImportarVerificarStatusSeletor: function () {
      // VERIFICA SE TEM ALGUM ARQUIVO SELECIONADO
      this.seletor.disabled = this.envio !== null
      
      // VERIFICA O STATUS DO CAMPO
      switch (this.seletor.disabled) {
        case true:
          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'ven-imp-box-upload', 'ven-imp-box-upload-dragover' ]
          break

        case false:
          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'ven-imp-box-upload' ]
          break
      }

      // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
      this.seletor.value = []

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    appVenImportarArquivoLer: function (file) {
      // SETA O VALOR RECEBIDO
      this.envio = 'validando'

      // INICIA A LEITURA DO ARQUIVO
      var reader = new FileReader()

      // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
      this.appVenImportarVerificarStatusSeletor()

      // SETA FUNÇÃO DE SUCESSO DE LEITURA
      reader.onload = () => {
        // PEGA O ARQUIVO RECEBIDO
        var arquivo = reader.result

        // SETA O VALOR RECEBIDO
        this.envio = arquivo

        // FAZ A VERIFICAÇÃO DE ERRO
        try {
          // CONVERTE EM OBJETO O VALOR RECEBIDO
          this.envio = JSON.parse(this.envio)

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/demanda/dem-venda/importar', 'POST', this.envio, (retorno) => {
            // TRATA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(retorno, null)

            // SETA O VALOR RECEBIDO
            this.envio = null

            // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
            this.appVenImportarVerificarStatusSeletor()
          }, () => {
            // SETA O VALOR RECEBIDO
            this.envio = null

            // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
            this.appVenImportarVerificarStatusSeletor()
          }, (apiValid, apiStatus) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this).then(() => {
              // SETA O VALOR RECEBIDO
              this.envio = null

              // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
              this.appVenImportarVerificarStatusSeletor()
            })
          })
        }
        catch (e) {
          // APRESENTA O ERRO RECEBIDO
          this.$store.state.msgWarn('WEB [500]: ' + e.message, 'danger')

          // SETA O VALOR RECEBIDO
          this.envio = null

          // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
          this.appVenImportarVerificarStatusSeletor()
        }
      }

      // FAZ A LEITURA DO ARQUIVO RECEBIDO
      reader.readAsBinaryString(file)
    }
  }
}
</script>
